var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1825_25513",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1501 0H0.150146V30H30.1501V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1825_25513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1599 5H13.49V28.33H25.1599V5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.53 0H5.77002C4.27858 0.00264909 2.84932 0.596984 1.79565 1.65253C0.741986 2.70807 0.150144 4.13857 0.150146 5.63V24.38C0.150146 25.8705 0.742188 27.3 1.79614 28.3539C2.8501 29.4079 4.2795 30 5.77002 30H24.53C26.0205 30 27.4502 29.4079 28.5042 28.3539C29.5581 27.3 30.1501 25.8705 30.1501 24.38V5.63C30.1501 4.13857 29.5583 2.70807 28.5046 1.65253C27.451 0.596984 26.0215 0.00264909 24.53 0ZM23.76 16.16H20.9602V26.55H16.27V16.16H14.4502V12.66H16.27V10.43C16.27 7.50999 17.4802 5.77002 20.9202 5.77002H24.4102V9.26001H22.4102C21.0602 9.26001 20.9802 9.76 20.9802 10.69V12.69H24.1702L23.79 16.19L23.76 16.16Z",
    fill: "#CCCBCB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLight);
export default __webpack_public_path__ + "static/media/FacebookLight.f7c3b92371da74ddc722f20e39b0824f.svg";
export { ForwardRef as ReactComponent };